module.exports = __webpack_public_path__ + "static/img/817.98310526.png";